import { memo, useCallback } from 'react';
import { motion } from 'framer-motion';
import { formatDateWithWeekday } from '@/utils/date';
import styles from './CharmingNaturalFooter.module.css';

type CharmingNaturalFooterProps = {
  brideName: string;
  groomName: string;
  weddingDate: string;
};

/**
 * Footer для премиум layout "Charming Natural"
 * Содержит логотип и дату свадьбы
 */
const CharmingNaturalFooter = memo(({
  brideName,
  groomName,
  weddingDate,
}: CharmingNaturalFooterProps) => {
  // Получаем первые буквы имен для логотипа (как в хедере)
  const logo = `${brideName.charAt(0).toUpperCase()}&${groomName.charAt(0).toUpperCase()}`;

  // Форматируем дату свадьбы
  const formattedWeddingDate = weddingDate
    ? formatDateWithWeekday(weddingDate)
    : '';

  // Функция для плавной прокрутки к началу страницы
  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.6 }}
      className={styles.footer}
    >
      <div className={styles.container}>
        <button
          type="button"
          onClick={scrollToTop}
          className={styles.logo}
          aria-label="Перейти на главную"
        >
          {logo}
        </button>
        {formattedWeddingDate && (
          <div className={styles.weddingDate}>{formattedWeddingDate}</div>
        )}
      </div>
    </motion.footer>
  );
});

CharmingNaturalFooter.displayName = 'CharmingNaturalFooter';

export default CharmingNaturalFooter;

